import React, {Component} from 'react';
import axios from 'axios';
import {toast} from 'react-toastify';

export default class ModalHideFilter extends Component {
    constructor(props) {
        super(props);

        this.state = {
            filterModel: null,
            loading: false
        }

        this.hideOrActiveFilter = this.hideOrActiveFilter.bind(this);
    }

    componentWillReceiveProps(props) {
        this.setState({
            filterModel : props.filterModel
        })
    }

    hideOrActiveFilter() {
        this.setState({
            loading: true
        });

        axios.post(global.config.apiDomain + '/rest/deepARFilter/hideOrActiveFilter', this.state.filterModel)
        .then(res => {
            this.setState({
                loading: false
            });

            if (res.data.status == "OK") {
                window.$("#modalHideFilter").modal("hide");
                toast.success(res.data.message); 
                this.props.resetList(this.state.filterModel.type);
            } else {
                toast.warning(res.data.message);
            }
        })
    }

    render() {
        const {filterModel} = this.state;

        return (
            <div>
                <div className="modal fade" id="modalHideFilter" tabIndex={-1} role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                    <div className="modal-dialog  modal-dialog-centered" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                            {(filterModel && filterModel.enable) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">ẨN Bộ lọc</h5>
                            ) : ""}
                            {(filterModel && !filterModel.enable) ? (
                                 <h5 className="modal-title" id="exampleModalLabel">HIỆN Bộ lọc</h5>
                            ) : ""}
                               
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            {(filterModel && filterModel.enable) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-danger">Bạn muốn ẨN Bộ lọc: <span className="font-weight-bold">{filterModel.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            {(filterModel && !filterModel.enable) ? (
                                <div className="modal-body">
                                <h3 className="text-center text-info">Bạn muốn HIỆN Bộ lọc: <span className="font-weight-bold">{filterModel.name}</span> ?</h3>
                            </div>
                            ) : ""}
                            <div className="modal-footer">
                                <button type="button" className="btn btn-red" data-dismiss="modal">Hủy</button>
                                {this.state.loading ? 
                                (
                                <button style={{width: "120px"}} className="btn btn-red" type="button" disabled>
                                <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                    Xác nhận...
                                </button>
                                ) :
                                (
                                <button 
                                    style={{width: "120px"}} 
                                    type="button" 
                                    className="btn btn-red"
                                    onClick={this.hideOrActiveFilter}>Xác nhận</button>    
                                )}                        
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}